const BASE = "http://klaes.info";

export async function apiPostAuth(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });

  const data = await res.json();

  if (!res.ok) {
    throw data;
  }

  return data;
}

// Neue Funktionen für UI-Props
export async function apiGetUserUiProps(token) {
  const res = await fetch(`${BASE}/api/user/ui-props`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data; // { ui_props: { ... } oder null }
}

export async function apiPutUserUiProps(token, uiProps) {
  const res = await fetch(`${BASE}/api/user/ui-props`, {
    method: "PUT",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ ui_props: uiProps })
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

// Hole das Profil des aktuell eingeloggten Users
export async function apiGetUserProfile(token) {
  const res = await fetch(`${BASE}/api/user/profile`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data; // { user: { ... } }
}

// Aktualisiere Profilfelder
export async function apiPutUserProfile(token, profileData) {
  const res = await fetch(`${BASE}/api/user/profile`, {
    method: "PUT",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(profileData)
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data; // { user, message }
}


export async function apiGetOnlineUsers(token) {
  const res = await fetch(`${BASE}/api/online-users`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

export async function apiLogout(token) {
  const res = await fetch(`${BASE}/api/auth/logout`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}